// src/config/privateRoutes.js
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext"; // Import the custom hook

export const ProtectedRoute = ({ children }) => {
  const { user, isFetching } = useAuth(); // Get user and isFetching from context

  if (isFetching) {
    return <div>Loading...</div>; // Optional loading state
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
};
